export default __webpack_public_path__ + "static/media/logo_vrc.ce83a3ca.png";